import { render } from "./dispatched.vue?vue&type=template&id=291fc73c&scoped=true"
import script from "./dispatched.vue?vue&type=script&lang=js"
export * from "./dispatched.vue?vue&type=script&lang=js"

import "./dispatched.vue?vue&type=style&index=0&id=291fc73c&scoped=true&lang=css"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-291fc73c"]])

export default __exports__